import entries from '../data/portfolioProjects.json'

function richTextToPlain(node) {
  if (!node) return ''
  // node may be a root document or text node
  if (node.nodeType === 'text') return node.value || ''
  if (Array.isArray(node)) return node.map(richTextToPlain).join(' ')
  if (node.content && Array.isArray(node.content)) {
    return node.content.map(richTextToPlain).join(' ')
  }
  return ''
}

// helper to map a project entry to our app's shape
function mapProject(it) {
  const fields = it.fields || {}
  const title = fields.title || fields.name || ''

  const assetUrl = (asset) => {
    const url = asset?.fields?.file?.url
    return url ? (url.startsWith('//') ? `https:${url}` : url) : undefined
  }

  const gallery = [
    ...(Array.isArray(fields.gallery) ? fields.gallery : []),
    ...(Array.isArray(fields.projectGallery) ? fields.projectGallery : []),
    ...(Array.isArray(fields.media) ? fields.media : []),
  ].map((asset) => ({
    url: assetUrl(asset),
    title: asset?.fields?.title || asset?.fields?.description || title,
  })).filter((asset) => asset.url)

  const moodboard = [
    ...(Array.isArray(fields.moodboard) ? fields.moodboard : []),
    ...(!Array.isArray(fields.moodboard) && fields.moodboard?.fields?.file ? [fields.moodboard] : []),
    ...(Array.isArray(fields.moodboardImages) ? fields.moodboardImages : []),
    ...(Array.isArray(fields.visualDirection) ? fields.visualDirection : []),
  ].map((asset) => ({
    url: assetUrl(asset),
    title: asset?.fields?.title || asset?.fields?.description || `${title} moodboard`,
  })).filter((asset) => asset.url)

  // Handle rich text description fields by converting to plain text
  const rawDescription = fields.description || fields.details || ''
  const description = typeof rawDescription === 'string' ? rawDescription : richTextToPlain(rawDescription)
  const link = fields.projectLink || fields.link || fields.externalLink || '#'
  const imageUrl = fields.projectImage?.fields?.file?.url ? assetUrl(fields.projectImage) : (fields.coverImage?.fields?.file?.url ? assetUrl(fields.coverImage) : undefined)

  return {
    id: it.sys?.id,
    title,
    details: description,
    link,
    image: imageUrl,
    category: fields.category,
    slug: fields.slug,
    isExternalProjectLink: fields.isExternalProjectLink,
    myRole: fields.myRole,
    timeline: fields.timeline,
    tools: fields.tools || fields.toolsUsed,
    theProblem: fields.theProblem,
    goals: fields.goals,
    constraints: fields.constraints,
    solutionOverview: fields.solutionOverview,
    productDecisionsAndImplementation: fields.productDecisionsAndImplementation,
    impact: fields.impact,
    nextSteps: fields.nextSteps,
    overview: fields.overview || fields.projectOverview || fields.description,
    responsibilities: fields.responsibilities || fields.myResponsibilities,
    discoveryAndResearch: fields.discoveryAndResearch || fields.research || fields.discovery,
    process: fields.process || fields.designProcess || fields.approach,
    challenges: fields.challenges || fields.keyChallenges,
    results: fields.results || fields.outcomes,
    learnings: fields.learnings || fields.reflections || fields.keyLearnings,
    team: fields.team || fields.collaborators,
    year: fields.year,
    duration: fields.duration,
    moodboard,
    moodboardDescription: fields.moodboardDescription || fields.visualDirectionDescription || fields.artDirection,
    gallery,
    secondaryLink: fields.secondaryLink || fields.repositoryLink,
    secondaryLinkLabel: fields.secondaryLinkLabel || (fields.repositoryLink ? 'View repository' : 'View project'),
    _raw: fields,
  }
}

const projects = entries.map(mapProject)

export async function fetchPortfolioProjects({ limit = 100 } = {}) {
  return projects.slice(0, limit)
}

export async function fetchProjectBySlug(slug) {
  return projects.find(project => project.slug === slug) || null
}
